import { render } from "./callback.vue?vue&type=template&id=fa9c5c62&scoped=true"
import script from "./callback.vue?vue&type=script&lang=js"
export * from "./callback.vue?vue&type=script&lang=js"

import "./callback.vue?vue&type=style&index=0&id=fa9c5c62&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9c5c62"]])

export default __exports__